// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"72c67d1fc4c7b934","2931":"a3e990da3b268a62"}[chunkId] + ".css";
};